import { Injectable } from "@angular/core";
import { MatTabChangeEvent } from "@angular/material";

/**
 * error: 'ClientRect | DOMRect' is not assignable to type 'DOMRect'
 * Using DomRectI instead
 */
interface DOMRectI {
  bottom: number;
  height: number;
  left: number; // position start of element
  right: number; // position end of element
  top: number;
  width: number; // width of element
  x?: number;
  y?: number;
}

@Injectable({
  providedIn: "root"
})
export class MaterialTabHelperService {

  constructor(
  ) { }

  /**
   * to handle animation on Material tabs header
   * by selecting each tab, it must move to the center of header.
   * last tab stay at the end. first tab will stay at the begining
   * MatTabGroup tag must have an id attribute: id="headerTabs"
   */
  public TabHeaderTranslateAnimation(event: MatTabChangeEvent) {
    const me = this;
    const headerTabs = document.getElementById("headerTabs");
    const matTabLabels = Array.from(headerTabs.getElementsByClassName("mat-tab-label"));
    const targetMatTabLabel = matTabLabels[event.index] as HTMLElement;
    const scrollContainer = headerTabs.querySelector('.mat-tab-list');
    const currentScrolledContainerPosition: number = scrollContainer.scrollLeft;
    const newPositionScrollTo = me.calcScrollToCenterValue(targetMatTabLabel, currentScrolledContainerPosition);

    scrollContainer.scroll({
      left: newPositionScrollTo,
      behavior: 'smooth',
    });
  }

  /**
 * is used when you change to desired site and only have the indexNumber available
 * to handle animation on Material tabs header
 * by selecting each tab, it must move to the center of header.
 * last tab stay at the end. first tab will stay at the begining
 * MatTabGroup tag must have an id attribute: id="headerTabs"
 */
  public TabHeaderTranslateAnimationWithIndex(iDNumber: number = 0) {
    const me = this;
    const headerTabs = document.getElementById("headerTabs");
    const matTabLabels = Array.from(headerTabs.getElementsByClassName("mat-tab-label"));
    const targetMatTabLabel = matTabLabels[iDNumber] as HTMLElement;
    const scrollContainer = headerTabs.querySelector('.mat-tab-list');
    const currentScrolledContainerPosition: number = scrollContainer.scrollLeft;
    const newPositionScrollTo = me.calcScrollToCenterValue(targetMatTabLabel, currentScrolledContainerPosition);

    scrollContainer.scroll({
      left: newPositionScrollTo,
      behavior: 'smooth',
    });
  }

  /**
   * to handle problem for focus change event  when swipng left or right
   * click on target tab couse the focus event fire.
   */
  public handleTabFocusChange(targetIndex: number) {
    const me = this;
    const headerTabs = document.getElementById("headerTabs");
    const matTabLabels = Array.from(headerTabs.getElementsByClassName("mat-tab-label"));
    const targetMatTabLabel = matTabLabels[targetIndex] as HTMLElement;
    targetMatTabLabel.click();
    targetMatTabLabel.blur();
  }

  /**
   * Calculate new Position to Scroll to
   */
  private calcScrollToCenterValue(clickedElement: HTMLElement, currentScrolledContainerPosition): number {
    const scrolledButton: DOMRectI = clickedElement.getBoundingClientRect();
    const leftXOffset = (window.innerWidth - scrolledButton.width) / 2;
    const currentVisibleViewportLeft = scrolledButton.left;
    const neededLeftOffset = currentVisibleViewportLeft - leftXOffset;
    const newValueToSCroll = currentScrolledContainerPosition + neededLeftOffset;
    return newValueToSCroll;
  }
}